import React from "react";
import AnimatedDialogLayout from "./AnimatedDialogLayout";
import useDialog from "hooks/useDialog";

const TrialWelcomeDialog = () => {
  const { isTrialWelcomeDialogOpen, closeTrialWelcomeDialog } = useDialog();

  const handleContinue = async () => {
    closeTrialWelcomeDialog();
  };

  const handleClose = async () => {
    closeTrialWelcomeDialog();
  };

  return (
    <AnimatedDialogLayout
      isOpen={isTrialWelcomeDialogOpen}
      onClose={handleClose}
    >
      <div className="max-w-lg w-full sm:w-[500px] text-center py-6">
        {/* Gift/Celebration Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-gradient-to-r from-primary to-[#FF6B6B] rounded-full flex items-center justify-center">
            <span className="text-3xl">🎉</span>
          </div>
        </div>

        {/* Welcome Message */}
        <h1 className="text-black font-bold text-[24px] mb-4 leading-[30px]">
          Benvenuto in HouseScan!
        </h1>

        <h2 className="text-primary font-semibold text-[20px] mb-4 leading-[26px]">
          Hai ricevuto 15 giorni gratuiti! 🎁
        </h2>

        <p className="text-[#1A1A1A] text-[16px] font-normal leading-[22px] mb-6">
          Goditi tutte le funzionalità premium di HouseScan gratuitamente per 15
          giorni. Esplora proprietà, salva le tue ricerche, organizza i tuoi
          preferiti e molto altro!
        </p>

        <button
          onClick={handleContinue}
          className="bg-primary hover:bg-opacity-90 text-white rounded-[11px] h-[51px] w-full font-semibold text-[18px] transition-all duration-300 ease-in-out"
        >
          Inizia ad Esplorare
        </button>

        <p className="text-[#999999] text-[12px] font-normal leading-[16px] mt-4">
          Il tuo periodo di prova terminerà automaticamente dopo 15 giorni
        </p>
      </div>
    </AnimatedDialogLayout>
  );
};

export default TrialWelcomeDialog;
